import { mutationOptions } from '@tanstack/react-query';

import type { GymFinderService } from 'app/features/leads/services/gym-finder';
import type { BulkUpdateLeadStatusParams } from 'app/features/leads/services/gym-finder/types';

type LeadBulkStatusUpdateService = Pick<GymFinderService, 'bulkUpdateLeadStatus'>;

export const bulkUpdateLeadStatusMutationOptions = (service: LeadBulkStatusUpdateService) =>
  mutationOptions({
    mutationFn: ({ ids, status }: BulkUpdateLeadStatusParams) => service.bulkUpdateLeadStatus(ids, status),
  });
